<template>
	<div class="cont_box">
		<div class="gall_box bai_box">
			<div class="gall_mbx">
				<el-breadcrumb separator=">">
					<el-breadcrumb-item>当前位置</el-breadcrumb-item>
					<el-breadcrumb-item>近似种类</el-breadcrumb-item>
				</el-breadcrumb>
				<div class="insect_story">
					<div class="insect_story_box">
						<div class="insect_story_cont">
							<div class="insect_story_item" @click="stor_btn(item)" v-for="(item,index) of storyList.records" :key="index">
								<img oncontextmenu="return false;" ondragstart="return false;" :src="item.coverUrl" alt="" class="bag">
								<div class="insect_story_item_rig">
									<div class="insect_story_item_title">
										{{item.title}}
									</div>
									<div class="insect_story_item_p">
										{{item.content}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="gall_fy">
					<div class="block">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="storyList.current"
						 :page-size="storyList.size" layout="prev, pager, next, jumper" :total="storyList.total">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import headers from '@/components/header';
	import foot from '@/components/foot';
	export default {
		name: "UserDialong",
		data() {
			return {
				not_flag: true,
				tab_index: 'tpgs',
				pares: {
					page: 1,
					size: 10
				},
				storyList: {
					current: 1,
					size: 1,
					pages: 1,
				}, // 图片故事列表
			}
		},
		mounted() {
			this.init()
		},
		methods: {
			init() {
				this.$http.post('/front/picture/store/list',{
					page: this.pares.page,
					size: this.pares.size,
				}).then(res => {
					let data = res.data
					for (let item of data.records) {
						item.content = item.content.replace(/<[^<>]+>/g, '').replace(/&nbsp;/ig, '').trim()
					}
					this.storyList = data
					console.log(res)
				})
			},
			stor_btn(item) {
				this.$router.push({
					name:'story_dec',
					query: {
						id: item.id
					}
				})
			},
			slt_btn() {
				this.$router.push({path:'gallery_indexTw'})
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				this.pares.page = val
				this.init()
			}
		},
		components: {
			headers,
			foot,
		}
	}
</script>

<style lang="less" scoped>
	.insect_story {
		.insect_story_box {
			margin: 0 auto;
			padding: 40px 0 0;
			box-sizing: border-box;
			background-color: #fff;
	
			.insect_story_title {
				height: 65px;
				display: flex;
				align-items: center;
				justify-content: space-between;
	
				.insect_story_name {
					font-size: 18px;
					font-weight: bold;
				}
	
				.insect_story_more {
					display: flex;
					align-items: center;
	
					span {
						font-size: 12px;
						margin-right: 13px;
						line-height: 1;
					}
	
					.icon {
						width: 18px;
						height: 18px;
					}
				}
			}
	
			.insect_story_cont {
				.insect_story_item {
					display: flex;
					padding: 21px 0 23px;
					border-bottom: 1px solid #E5E5E5;
					cursor: pointer;
	
					.bag {
						width: 225px;
						height: 135px;
						object-fit: cover;
						margin-right: 23px;
					}
	
					.insect_story_item_rig {
						flex: 1;
	
						.insect_story_item_title {
							padding-top: 15px;
							margin-bottom: 20px;
							font-weight: bold;
							font-size: 18px;
						}
	
						.insect_story_item_p {
							font-size: 14px;
							color: #4A4A4A;
							line-height: 1.5;
							overflow: hidden;
							text-overflow: ellipsis;
							/*! autoprefixer: off */
							display: -webkit-box;
							-webkit-line-clamp: 4;
							-webkit-box-orient: vertical;
						}
					}
				}
			}
		}
	}
	.gall_box{
		//width: 870px;
		width: 1200px;
		margin: 0 auto;
		.gall_mbx{
			margin: 0 0 30px;
			padding: 37px 23px 1px;
			span{
				font-size: 13px;
			}
		}
		.gall_fy{
			margin: 30px 0;
			.block{
				display: flex;
				justify-content: center;
			}
		}
	}
</style>
